import {
    LeftNavItemType,
    groupHubUrlKey,
    groupHubMemberFolderUrlKey,
    groupHubDeletedFolderUrlKey,
    groupHubOwnerFolderUrlKey,
} from 'people/lib/shared';

export function getRouteForCurrentGroup(groupEmailAddress: string) {
    var groupInfo = groupEmailAddress.split('@');
    return groupInfo.length == 2 ? [groupHubUrlKey, groupInfo[1], groupInfo[0]] : [groupHubUrlKey];
}

export function getRouteForGroupFolder(leftNavItemType: LeftNavItemType) {
    let route: string;
    if (leftNavItemType === LeftNavItemType.JoinedGroups) {
        route = groupHubMemberFolderUrlKey;
    } else if (leftNavItemType === LeftNavItemType.OwnedGroups) {
        route = groupHubOwnerFolderUrlKey;
    } else if (leftNavItemType === LeftNavItemType.DeletedGroups) {
        route = groupHubDeletedFolderUrlKey;
    }
    return route ? [groupHubUrlKey, route] : [];
}
